// extracted by mini-css-extract-plugin
module.exports = {"input":"TemplatesToolbarInput_input__1njIH","inputContainer":"TemplatesToolbarInput_inputContainer__3yaxA","closeIconButton":"TemplatesToolbarInput_closeIconButton__3shOn"};